import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { handleEditUniversity } from '../../../../store/actionCreators/university';

class Informations extends Component {
    state= {
        state: "info",
        ar_name: "",
        email: "",
        phone: "",
        website: "",
        address: "",
        getError: {
            state: false,
            message: ""
        },
        editError: {
            state: false,
            message: ""
        },
    }

    componentDidMount() {
        if (this.props.university !== null) {
            const { ar_name, email, phone, website, address } = this.props.university;
            this.setState({ ar_name, email, phone, website, address })
        }
    }
    
    changState = value => {
        this.setState({state: value})
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    updateInfo = () => {
        const { ar_name, email, phone, website, address } = this.state;
        const data = { ar_name, email, phone, website, address }
        this.props.dispatch(handleEditUniversity(this.props.university._id, data))
        .then(result => {
            if (result.error && result.error !== null) {
                this.setState({
                    editError: {
                        state: true,
                        message: result.error.message
                    }
                })
            } else {
                this.setState({
                    state: "info"
                })
            }
        })
    }

    render() {
        const { state, ar_name, email, phone, website, address } = this.state;
        // console.log(this.state)
        if (this.props.university && this.props.university !== null) {
            return (
                <div className="uni-info p-2 p-lg-5">
                    <div className="d-flex justify-content-between p-2">
                        <img src={this.props.university.logo && this.props.university.logo!==null ? this.props.university.logo : "/images/university-blank.jpg"} alt="logo" width="200" height="200" />
                        {state === "edit"
                            ? <div>
                                <button className="blue-btn px-4 py-2 align-self-start mx-1" onClick={this.updateInfo}>حفظ</button>
                                <button className="edit-btn px-4 py-2 align-self-start mx-1" onClick={() => this.changState("info")}>إلغاء</button>
                            </div>
                            : <button className="edit-btn px-4 py-2 align-self-start" onClick={() => this.changState("edit")}>تعديل</button>
                        }
                        
                    </div>
                    {state === "edit"
                        ? <form className="my-4 d-flex flex-wrap">
                            <div className="m-5">
                                <div className="alert alert-danger text-center mb-5 fs-5" role="alert" style={{display: this.state.editError.state ? "block" : "none"}}>
                                    {this.state.editError.message}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 p-2"><input type="text" className="p-3" name="ar_name" value={ar_name} placeholder="اسم الجامعة" onChange={this.handleChange} /></div>
                                <div className="col-lg-6 p-2"><input type="email" className="p-3" name="email" value={email} placeholder="البريد الإلكتروني" onChange={this.handleChange} /></div>
                                <div className="col-lg-6 p-2"><input type="text" className="p-3" name="phone" value={phone} placeholder="" onChange={this.handleChange} /></div>
                                <div className="col-lg-6 p-2"><input type="text" className="p-3" name="website" value={website} placeholder="الموقع الإلكتروني" onChange={this.handleChange} /></div>
                                <div className="col p-2"><input type="text" className="p-3" name="address" value={address} placeholder="العنوان" onChange={this.handleChange} /></div>
                                {/* <div className="col-12 p-2"><h4 className="p-3 position-relative location">الإحداثيات<span className="map-icon"><img src="/icons/maps.png" alt="location" /></span></h4></div> */}
                            </div>
                        </form>
                        : <div className="my-4 d-flex flex-wrap">
                            <div className="row">
                                <div className="col-lg-6 p-2"><h4 className="p-3">{this.props.university.ar_name}</h4></div>
                                <div className="col-lg-6 p-2"><h4 className="p-3">{this.props.university.email}</h4></div>
                                <div className="col-lg-6 p-2"><h4 className="p-3">{this.props.university.phone}</h4></div>
                                <div className="col-lg-6 p-2"><h4 className="p-3">{this.props.university.website}</h4></div>
                                <div className="col p-2"><h4 className="p-3">{this.props.university.address}</h4></div>
                                {/* <div className="col-12 p-2"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d433870.82680052886!2d36.22782233213534!3d31.835453331226827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151b5fb85d7981af%3A0x631c30c0f8dc65e8!2z2LnZhdmR2KfZhtiMINin2YTYo9ix2K_Zhg!5e0!3m2!1sar!2seg!4v1628362206528!5m2!1sar!2seg" width="100%" height="410" title="address" style={{border:0, filter: "invert(90%)"}} allowFullScreen loading="lazy"></iframe></div> */}
                            </div>
                        </div>
                    }
                    
                </div>
            )
        } else {
            if (this.state.getError.state) {
                return (
                    <div className="m-5">
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert">
                            {this.state.getError.message}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="text-center m-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        }
    }
}

function mapStateToProps ({ university }) {
	return {
		university
	}
}

export default withRouter(connect(mapStateToProps)(Informations));